import { IFilter } from "@/models/tables";
import { FilterOperators, FilterTypes } from "@/data/table";
import { CreditNoteStatus } from "../enums/invoice";
import i18n from "@/i18n";

const creditNotesFilters: IFilter[] = [
  {
    key: "number",
    label: i18n.t("_.credit_note_id"),
    type: FilterTypes.STRING,
    operator: FilterOperators.EQUAL
  },
  {
    key: "total_amount",
    label: i18n.t("_.amount"),
    type: FilterTypes.NUMBER,
    operator: FilterOperators.EQUAL
  },
  {
    key: "status.code",
    label: i18n.t("_.status"),
    type: FilterTypes.SELECT_CHECKBOX,
    options: [
      {
        value: CreditNoteStatus.ALLOCATED,
        label: i18n.t("_.allocated").toString()
      },
      {
        value: CreditNoteStatus.UNALLOCATED,
        label: i18n.t("_.unallocated").toString()
      }
    ],
    operator: FilterOperators.EQUAL
  },
  {
    key: "create_datetime",
    label: i18n.t("_.date_created"),
    type: FilterTypes.DATE,
    operator: FilterOperators.EQUAL
  }
];

export default creditNotesFilters;
